module.exports = __webpack_public_path__ + "media/flags/ir-63ab499d.svg";